"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triangle = exports.Star07 = exports.Star06 = exports.Star05 = exports.Star04 = exports.Star03 = exports.Star02 = exports.Star01 = exports.Square = exports.Pentagon = exports.Octagon = exports.Hexagon02 = exports.Hexagon01 = exports.Dice6 = exports.Dice5 = exports.Dice4 = exports.Dice3 = exports.Dice2 = exports.Dice1 = exports.CubeOutline = exports.Cube04 = exports.Cube03 = exports.Cube02 = exports.Cube01 = exports.Circle = void 0;
var Circle_1 = require("./Circle");
Object.defineProperty(exports, "Circle", { enumerable: true, get: function () { return Circle_1.default; } });
var Cube01_1 = require("./Cube01");
Object.defineProperty(exports, "Cube01", { enumerable: true, get: function () { return Cube01_1.default; } });
var Cube02_1 = require("./Cube02");
Object.defineProperty(exports, "Cube02", { enumerable: true, get: function () { return Cube02_1.default; } });
var Cube03_1 = require("./Cube03");
Object.defineProperty(exports, "Cube03", { enumerable: true, get: function () { return Cube03_1.default; } });
var Cube04_1 = require("./Cube04");
Object.defineProperty(exports, "Cube04", { enumerable: true, get: function () { return Cube04_1.default; } });
var CubeOutline_1 = require("./CubeOutline");
Object.defineProperty(exports, "CubeOutline", { enumerable: true, get: function () { return CubeOutline_1.default; } });
var Dice1_1 = require("./Dice1");
Object.defineProperty(exports, "Dice1", { enumerable: true, get: function () { return Dice1_1.default; } });
var Dice2_1 = require("./Dice2");
Object.defineProperty(exports, "Dice2", { enumerable: true, get: function () { return Dice2_1.default; } });
var Dice3_1 = require("./Dice3");
Object.defineProperty(exports, "Dice3", { enumerable: true, get: function () { return Dice3_1.default; } });
var Dice4_1 = require("./Dice4");
Object.defineProperty(exports, "Dice4", { enumerable: true, get: function () { return Dice4_1.default; } });
var Dice5_1 = require("./Dice5");
Object.defineProperty(exports, "Dice5", { enumerable: true, get: function () { return Dice5_1.default; } });
var Dice6_1 = require("./Dice6");
Object.defineProperty(exports, "Dice6", { enumerable: true, get: function () { return Dice6_1.default; } });
var Hexagon01_1 = require("./Hexagon01");
Object.defineProperty(exports, "Hexagon01", { enumerable: true, get: function () { return Hexagon01_1.default; } });
var Hexagon02_1 = require("./Hexagon02");
Object.defineProperty(exports, "Hexagon02", { enumerable: true, get: function () { return Hexagon02_1.default; } });
var Octagon_1 = require("./Octagon");
Object.defineProperty(exports, "Octagon", { enumerable: true, get: function () { return Octagon_1.default; } });
var Pentagon_1 = require("./Pentagon");
Object.defineProperty(exports, "Pentagon", { enumerable: true, get: function () { return Pentagon_1.default; } });
var Square_1 = require("./Square");
Object.defineProperty(exports, "Square", { enumerable: true, get: function () { return Square_1.default; } });
var Star01_1 = require("./Star01");
Object.defineProperty(exports, "Star01", { enumerable: true, get: function () { return Star01_1.default; } });
var Star02_1 = require("./Star02");
Object.defineProperty(exports, "Star02", { enumerable: true, get: function () { return Star02_1.default; } });
var Star03_1 = require("./Star03");
Object.defineProperty(exports, "Star03", { enumerable: true, get: function () { return Star03_1.default; } });
var Star04_1 = require("./Star04");
Object.defineProperty(exports, "Star04", { enumerable: true, get: function () { return Star04_1.default; } });
var Star05_1 = require("./Star05");
Object.defineProperty(exports, "Star05", { enumerable: true, get: function () { return Star05_1.default; } });
var Star06_1 = require("./Star06");
Object.defineProperty(exports, "Star06", { enumerable: true, get: function () { return Star06_1.default; } });
var Star07_1 = require("./Star07");
Object.defineProperty(exports, "Star07", { enumerable: true, get: function () { return Star07_1.default; } });
var Triangle_1 = require("./Triangle");
Object.defineProperty(exports, "Triangle", { enumerable: true, get: function () { return Triangle_1.default; } });
